import base from '@/__vue2stone/service/wasaapi/v1/__base';
import store from '@/store';
import i18n from '@/i18n';
export default {
  async articleShow(factoryId, articleId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.show({
      url: `factory/${factoryId}/article/${articleId}`,
      params: _params,
    });
    return res;
  },
  async articleVersionShow(factoryId, articleId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.show({
      url: `factory/${factoryId}/article_version/${articleId}`,
      params: _params,
    });
    return res;
  },
  async articleIndex(factoryId, actVersionId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.index({
      url: `factory/${factoryId}/article_version/${actVersionId}/article`,
      params: _params,
      pagination: true,
    });
    return res;
  },
  async articleVersionIndex(factoryId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.index({
      url: `factory/${factoryId}/article_version`,
      params: _params,
      pagination: true,
    });
    return res;
  },
  setArticleVersionContent(data) {
    const _actVersion = data.act_version
      ? data.act_version
      : data.act_versions[0];
    return {
      title: _actVersion.name + ' ' + data.no_text,
      content: data.rich_content ? '' : data.content,
      rich_content: data.rich_content,
      commentTitle: i18n.t('ESGoal評析'),
      riskSignal: data.effects,
      commentContent: data.ll_comment,
    };
  },
  //article popup
  async getLawContent(factoryId, articleId, params = null) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.show({
      url: `factory/${factoryId}/article_version/${articleId}`,
      params: _params,
    });
    return res;
  },
  //article popup
  getLawData(article) {
    const data = {
      title: `${
        article.act_version
          ? article.act_version.name
          : article.act_versions[0].name
      } ${article.no_text}`,
      content: article.content,
      rich_content: article.rich_content,
      riskSignal: article.effects,
      commentContent: article.ll_comment,
      commentTitle:
        article.effects.length > 0 || article.ll_comment
          ? i18n.t('ESGoal評析')
          : '',
    };
    return data;
  },
  async versionIndexSearch(params) {
    const factoryId = store.state.app.factory.id;
    const _params = {
      factory: factoryId,
      ...params,
    };
    const res = await base.index({
      url: `factory/${factoryId}/article_version/index/search`,
      params: _params,
      pagination: true,
    });
    return res;
  },
};
